import { useApolloClient } from '@apollo/client';
import { useAuthContext } from '@authentication/Authentication';
import { TransitionScreen } from '@components/transition';

export const PageLoader = ({ children }: { children: React.ReactNode }) => {
  // Verify Apollo client is available
  try {
    useApolloClient();
  } catch {
    return <TransitionScreen />;
  }

  // Verify Auth client is available and user is authenticated.
  // The hook order changes if Apollo is unavailable on first render (early return above)
  // and then becomes available on a later render. Tolerated because the transition is
  // one-way: once both providers mount, the component stays mounted and the call order
  // stabilizes. A proper fix would replace this guard pattern with an ErrorBoundary.
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { authenticated } = useAuthContext();
    if (!authenticated) {
      return <TransitionScreen />;
    }
  } catch {
    return <TransitionScreen />;
  }

  return children;
};
